import { action, Action, thunk, Thunk } from 'easy-peasy';
import { getHoursAndMinutes } from '@meitu/saas-editor-core/es/utils/common-kit';
import { getLocaleStore } from '@/i18n';

export enum SAVE_TYPE {
    HANDLE = 'handle',
    AUTO = 'auto',
    DOWNLOAD = 'download',
}

export interface ISaveInfoModel {
    destroy: Action<ISaveInfoModel>;
    isSaving: boolean;
    isAutoSaving: boolean;
    saveTooltipText: string;
    saveType: SAVE_TYPE | '';
    setIsSaving: Action<ISaveInfoModel, boolean>;
    setSaveType: Action<ISaveInfoModel, SAVE_TYPE>;
    setIsAutoSaving: Action<ISaveInfoModel, boolean>;
    changeSaveTooltipText: Action<ISaveInfoModel, boolean>;
    resetSaveTooltipText: Action<ISaveInfoModel>;
    /**
     * 历史记录变更是否需要触发自动保存
     * 进入编辑器，只是替换模版，不需要触发自动保存
     */
    isNeedAutoSave: boolean;
    /** 设置历史记录变更是否需要触发自动保存 */
    setIsNeedAutoSave: Action<ISaveInfoModel, boolean>;
    /** 获取保存状态 */
    getSaveState: Thunk<
        ISaveInfoModel,
        undefined,
        any,
        {},
        { isNeedAutoSave: boolean; isAutoSaving: boolean; isSaving: boolean }
    >;
}

export const saveInfoModel: ISaveInfoModel = {
    destroy: action((state) => {
        state.isAutoSaving = false;
        state.isSaving = false;
        state.saveTooltipText = '';
        state.saveType = '';
        state.isNeedAutoSave = false;
    }),
    isSaving: false,
    isAutoSaving: false,
    saveType: '',
    saveTooltipText: '',
    setIsSaving: action((state, type) => {
        state.isSaving = type;
    }),

    setSaveType: action((state, type) => {
        state.saveType = type;
    }),

    setIsAutoSaving: action((state, type) => {
        state.isAutoSaving = type;
    }),

    changeSaveTooltipText: action((state, isSave) => {
        const { $t } = getLocaleStore();
        state.saveTooltipText = isSave
            ? $t((v, { r }) => r(v.editor.models.saved, [getHoursAndMinutes()]))
            : $t((v) => v.header.save);
    }),
    resetSaveTooltipText: action((state) => {
        state.saveTooltipText = '';
    }),

    isNeedAutoSave: false,
    setIsNeedAutoSave: action((state, type) => {
        state.isNeedAutoSave = type;
    }),

    /** 获取保存状态 */
    getSaveState: thunk((action, payload, helper) => {
        return {
            isNeedAutoSave: helper.getState().isNeedAutoSave,
            isAutoSaving: helper.getState().isAutoSaving,
            isSaving: helper.getState().isSaving,
        };
    }),
};
